import { Button } from "@/components/ui/button/Button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog/Dialog";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/select/Select";
import { useEffect, useState, SyntheticEvent } from "react";
import axios from "axios";
import RoomTransactions from "../RoomTransactions";
import { Input } from "@/components/ui/input/Input";
import { AvailableShiftsResponse } from "@/models/shift/AvailableShiftsResponse";

type Props = {
  onReject: (reason: string, reason_type: string) => void;
  title?: string;
  transactions?: AvailableShiftsResponse;
};

export function RejectDialog(props: Props) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [reasonType, setReasonType] = useState("");
  const [reasonsList, setReasonsList] = useState<any[]>([]);

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
    if (!newOpen) {
      setReason("");
      setReasonType("");
    }
  };

  useEffect(() => {
    const fetchReasons = async () => {
      try {
        const response = await axios.get(
          import.meta.env.VITE_API_URL + "reason/type?reason_type=Rejected"
        );
        if (response.data.status) {
          const reasons = response.data.data.map((item: any) => ({
            id: item.id,
            description: item.reason_description,
          }));
          setReasonsList(reasons);
        }
      } catch (error) {
        console.error("Error fetching reasons:", error);
      }
    };
    fetchReasons();
  }, []);

  const handleReject = (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    props.onReject(reason, reasonType);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogTrigger asChild>
        <Button variant="destructive">Reject</Button>
      </DialogTrigger>

      <DialogContent
        className="sm:max-w-xl"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Reject Borrowing</DialogTitle>
        </DialogHeader>

        {props.transactions && (
          <RoomTransactions
            isAccepting={false}
            transactions={props.transactions}
          />
        )}

        <div className="text-lg font-semibold">
          Are you sure you want to reject this borrowing?
        </div>

        <Select onValueChange={setReasonType} value={reasonType}>
          <SelectTrigger>
            <SelectValue placeholder="Select a reason type" />
          </SelectTrigger>
          <SelectContent>
            {reasonsList.map((reasonItem) => (
              <SelectItem key={reasonItem.id} value={reasonItem.description}>
                {reasonItem.description}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Input
          placeholder="Additional notes (Optional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        />

        <DialogFooter className="mt-4">
          <Button
            type="button"
            variant={"destructive"}
            onClick={handleReject}
            disabled={!reasonType}
            className="w-full transition-none
                       disabled:bg-slate-900 disabled:text-slate-500 
                       disabled:opacity-100 disabled:cursor-not-allowed"
          >
            Confirm Reject
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
